export default "__VITE_ASSET__CjSO95le__"